/* eslint-disable import/prefer-default-export */
import { Row } from 'components/Core/Grid';
import styled from 'styled-components';

export const FilterRow = styled(Row)`
  margin-bottom: 30px !important;

  .search-icons {
    display: flex;
    justify-content: flex-end;
  }

  svg {
    fill: #cfd8dc;
    &.selected {
      fill: var(--titan-blue-3);
    }
    font-size: var(--font-size-25);
    cursor: pointer;
    margin-left: 31px;
    > path {
      color: var(--grey-4);
    }
    @media (max-width: 767px) {
      margin-left: 15px;
      font-size: var(--font-size-20);
    }
  }

  .MuiChip-root {
    :last-of-type {
      margin-right: 0;
    }

    @media (max-width: 767px) {
      margin-right: 10px;
      padding: 2px 6px;
      height: 26px;
    }
  }
  .search-icon-container {
    margin-left: 0;
    padding: 2px 0;
    @media (max-width: 767px) {
      margin-right: 10px;
    }

    &:hover {
      fill: var(--titan-blue-4);
    }
  }
  .search-menu-popup {
    @media (max-width: 767px) {
      margin-top: 15px;
    }
  }

  @media (max-width: 767px) {
    .search-icons {
      display: none;
    }
  }
`;
